// React & Vendor Libs
import React from 'react';
import ReactDOM from 'react-dom';

// Copytrack
import Dashboard from './components/Dashboard';
import LibraryImage from './components/LibraryImage';

document.addEventListener('DOMContentLoaded', function(event) {

	// Copytrack Dashboard 
	let container = document.getElementById('mct-admin-dashboard');
	if (container) {
		ReactDOM.render((<Dashboard />), container);
	}

	// Media Library 
	let items = document.querySelectorAll('[data-mct-id]');
	items.forEach(item => {
		const mediaId = item.getAttribute('data-mct-id');
		ReactDOM.render((<LibraryImage mediaId={mediaId} />), item);
	});
});
